export default __webpack_public_path__ + "static/media/x.ca465742.svg";